import { Accordion as MuiAccordion, styled } from "@mui/material";

// Crear un componente Accordion estilizado
const Accordion = styled(MuiAccordion, {
  shouldForwardProp: (prop) => prop !== "noShadow",
})(({ noShadow }) => ({
  border: "1px solid rgba(186, 186, 186, 0.20)",
  boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.10)",
  backgroundColor: "#FEFEFE",

  "&&": {
    borderRadius: "16px", // Establece tu borderRadius personalizado
  },
  "&.Mui-expanded": {
    "&&": {
      borderRadius: "16px", // borderRadius personalizado para cuando está expandido
    },
    margin: 0,
  },
  "&:before": {
    display: "none",
  },

  ...(noShadow && {
    border: "none",
    boxShadow: "none",
  }),
}));

export { Accordion };
